import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19384 19887"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M10176 15321V6926l4605 4217-4605 4178zm-8706-2282V9170h7739v3869H1470zm14316-2283L9983 5494c-155-116-349-155-503-77-194 77-271 232-271 425v2361H967c-270 0-503 232-503 502v4837c0 271 233 503 503 503h8242v2437c0 194 116 349 271 426 193 77 386 39 503-77l5803-5301c232-232 232-580 0-774z"
        className="fil0"
      />
      <path
        d="M12420 5494c-193-193-503-155-696 39-194 193-155 503 38 696l5417 4952-5417 4953c-193 194-193 503-38 697 193 193 503 193 696 38l5804-5300c193-194 193-542 0-697l-5804-5378zM15980 0c278 0 503 225 503 503s-225 503-503 503-503-225-503-503 225-503 503-503zM11143 2438c278 0 503 225 503 503 0 277-225 502-503 502-277 0-503-225-503-502 0-278 225-503 503-503zM1470 2902c279 0 504 225 504 503 0 277-226 503-504 503-277 0-503-226-503-503 0-278 226-503 503-503zM5340 16947c278 0 503 225 503 502 0 279-225 504-503 504s-504-225-504-504c0-277 226-502 504-502zM15013 18881c277 0 502 225 502 503s-225 503-502 503c-279 0-503-225-503-503s224-503 503-503zM17876 15012c277 0 503 226 503 503 0 278-226 503-503 503-278 0-503-225-503-503 0-277 225-503 503-503zM1703 17914c-387 0-736-310-736-735 0-426 310-735 736-735s735 309 735 735c0 425-348 735-735 735zm0-2399c-929 0-1703 774-1703 1702 0 929 774 1703 1703 1703 928 0 1702-774 1702-1703 0-928-774-1702-1702-1702zM6036 1470c658 0 1199 542 1199 1200s-541 1199-1199 1199-1200-503-1200-1161c0-696 542-1238 1200-1238zm0 3405c1199 0 2167-967 2167-2167 0-1199-968-2166-2167-2166-1200 0-2166 967-2166 2166 0 1200 966 2167 2166 2167zM17914 4372c-270 0-503-232-503-503 1-271 233-503 503-503 271 0 503 232 503 503-38 310-271 503-503 503zm0-1934c-812 0-1470 657-1470 1470 0 812 658 1470 1470 1470 813 0 1470-658 1470-1470-38-813-696-1470-1470-1470z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
